import type { SubmitGate as SubmitGateData, SubmitGateCondition } from '@assessments/shared'

export interface SubmitGateProps {
  submitGate: SubmitGateData
}

function conditionLabel(condition: SubmitGateCondition, sectionsRemaining: number): string {
  switch (condition) {
    case 'terms':
      return 'Accept the Terms of Use'
    case 'org_profile':
      return 'Complete the Organizational Profile'
    case 'required_sections':
      return `Complete the remaining required section${sectionsRemaining === 1 ? '' : 's'} (${sectionsRemaining})`
    case 'deadline':
      return 'The submission window for this assessment has closed'
  }
}

/** Why Submit is disabled. `unmet` is empty once ready or submitted, so nothing renders. */
export function SubmitGate({ submitGate }: SubmitGateProps) {
  if (submitGate.unmet.length === 0) return null

  const windowClosed = submitGate.unmet.includes('deadline')
  return (
    <section
      aria-labelledby="submit-gate-title"
      className="mb-8 rounded-lg border border-border bg-surface p-5 shadow-card"
    >
      <h2 id="submit-gate-title" className="text-base font-semibold text-body">
        {windowClosed ? 'Submission closed' : 'Before you can submit'}
      </h2>
      <ul className="mt-2 list-disc space-y-1 pl-5 text-[15px] text-subtle">
        {submitGate.unmet.map((condition) => (
          <li key={condition}>{conditionLabel(condition, submitGate.requiredSectionsRemaining)}</li>
        ))}
      </ul>
    </section>
  )
}
